<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title i18n=":@@modal_sibs_payment_request.title">Pedido de pagamento</ion-title>

        <ion-button *ngIf="State == EnumState.Confirm" title="fechar" style="margin-right: -16px;" fill="clear"
            color="dark" shape="round" slot="end" (click)="OnCancel()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

    <div class="summary">

        <!-- confirmação da operação -->
        <ng-container *ngIf="State == EnumState.Confirm">

            <!-- aviso: o pagamento é concluído no TPA, dentro do tempo limite -->
            <ion-row class="alert-warning">
                <ion-icon name="warning-outline"></ion-icon>
                <p i18n=":@@modal_sibs_payment_request.warning">Após confirmar, o cliente tem {{Minutes}} minutos para
                    efetuar o pagamento no terminal.</p>
            </ion-row>

            <ion-row class="note">
                <ion-col size="12">
                    <p class="message" i18n=":@@modal_sibs_payment_request.message">Está prestes a iniciar o pedido de
                        pagamento.</p>
                    <p i18n=":@@modal_sibs_payment_request.note">Verifique atentamente os dados antes de prosseguir:</p>
                </ion-col>
            </ion-row>

            <!-- valor em destaque -->
            <ion-row class="highlight ion-justify-content-center ion-text-center" *ngIf="Highlight as hl">
                <ion-col size="12">
                    <span class="highlight-label">{{hl.Label}}</span>
                    <span class="highlight-value">{{hl.Value}}</span>
                </ion-col>
            </ion-row>

            <!-- detalhes da operação -->
            <div class="details">
                <div class="detail" *ngFor="let item of Details">
                    <ion-icon class="detail-icon" [name]="item?.Icon || 'ellipse-outline'"></ion-icon>
                    <div class="detail-text">
                        <span class="detail-label">{{item?.Label}}</span>
                        <span class="detail-value">{{item?.Value || '--'}}</span>
                    </div>
                </div>
            </div>

            <!-- no fim do conteúdo: fica no fundo do modal e, sem espaço, só se alcança com scroll -->
            <div class="summary-footer">
                <div class="footer-text">
                    <p class="question" i18n=":@@modal_sibs_payment_request.question">Confirma que os dados estão
                        corretos?</p>
                </div>

                <div class="actions">
                    <ion-button fill="outline" color="primary" (click)="OnCancel()"
                        i18n=":@@modal_sibs_payment_request.cancel">Cancelar</ion-button>
                    <ion-button fill="solid" color="primary" (click)="OnConfirm()"
                        i18n=":@@modal_sibs_payment_request.confirm">Confirmar</ion-button>
                </div>
            </div>

        </ng-container>

        <!-- a aguardar pagamento no TPA -->
        <ng-container *ngIf="State == EnumState.Waiting">

            <!-- aviso: o terminal onde o cliente deve pagar -->
            <ion-row class="alert-warning" *ngIf="!IsExpired">
                <ion-icon name="warning-outline"></ion-icon>
                <p i18n=":@@modal_sibs_payment_request.waiting-warning">Peça ao cliente para apresentar o cartão no
                    terminal.</p>
            </ion-row>

            <ion-row class="waiting ion-justify-content-center ion-text-center">
                <ion-col size="12">
                    <p *ngIf="!IsExpired" i18n=":@@modal_sibs_payment_request.waiting-text">A aguardar o pagamento no TPA</p>
                    <p *ngIf="IsExpired" i18n=":@@modal_sibs_payment_request.expired-text">Tempo esgotado. Cancele para
                        tentar novamente.</p>
                    <h1 class="countdown">{{RemainingTime}}</h1>
                    <ion-progress-bar color="primary" [value]="Progress"></ion-progress-bar>
                </ion-col>
            </ion-row>

            <div class="summary-footer">
                <div class="footer-text" *ngIf="!IsExpired">
                    <p class="question" i18n=":@@modal_sibs_payment_request.paid-question">O cliente já efetuou o
                        pagamento?</p>
                </div>

                <div class="actions">
                    <ion-button *ngIf="!IsExpired" fill="solid" color="primary" (click)="OnPaymentConfirmed()"
                        i18n=":@@modal_sibs_payment_request.payment-confirmed">Confirmar</ion-button>
                    <ion-button *ngIf="IsExpired" fill="outline" color="primary" (click)="OnCancel()"
                        i18n=":@@modal_sibs_payment_request.cancel-expired">Cancelar</ion-button>
                </div>
            </div>

        </ng-container>

    </div>

</ion-content>
